/**
 * 카드 결제 UI 노출 여부. CE-2/CE-3(카드 빌링키 암호화 쓰기 전환) 완료 전까지
 * 운영에서만 카드 등록/결제 UI를 잠그기 위한 빌드타임 플래그.
 * (.env.development=true, .env.production=false)
 *
 * 결제 도메인 안전장치라 fail-closed로 설계 - 값이 정확히 'true'가 아니면(누락,
 * 오타, 빌드 설정 실수 등) 비활성으로 취급한다.
 */
export const isCardPaymentEnabled = process.env.REACT_APP_PAYMENT_CARD_ENABLED === 'true';

/**
 * workspaceApi(Workspace 통합 모델 3단계 API) 호출 여부. 백엔드 workspace.api.enabled와
 * 짝을 맞춰야 하는 별개 플래그(각자 환경파일에서 독립적으로 관리) - 꺼져 있으면
 * workspaceApi 호출 자체를 하지 않는다(레거시 teamApi만 사용).
 * (.env.development=false, .env.production=false - 로컬에서 켜서 검증할 땐 커밋되지
 * 않는 .env.local이나 셸 환경변수로 오버라이드할 것, BE WORKSPACE_API_ENABLED와 동일한
 * "임시 오버라이드" 원칙)
 *
 * fail-closed로 설계 - 값이 정확히 'true'가 아니면(누락, 오타 등) 비활성으로 취급한다.
 */
export const isWorkspaceApiEnabled = process.env.REACT_APP_WORKSPACE_API_ENABLED === 'true';
